import {
  AnalyticsFieldName,
  ProfileAnalyticsEvent,
} from "@/constants/analytics/Analytics";
import { ModalPath } from "@/constants/Navigation";
import { SafetyPlanTestID } from "@/constants/TestID";
import { useAnalytics } from "@/services/Analytics";
import { useAppUserSelector } from "@/store/reducers/appUser";
import ChatSuicideLineSection from "@/ui/components/profile/safetyPlan/ChatSuicideLineSection";
import HotlinesSection from "@/ui/components/profile/safetyPlan/HotlinesSection";
import type { LinkPressProps } from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import TextCrisisNumberSection from "@/ui/components/profile/safetyPlan/TextCrisisNumberSection";
import WebsiteWithCrisisSkillsSection from "@/ui/components/profile/safetyPlan/WebsiteWithCrisisSkillsSection";
import { Text } from "@/ui/core";
import { VStack } from "@/ui/layout";

const ContactInfo = {
  crisis: "741741",
  crisisSkillsUrl: "https://nowmattersnow.org",
  crisisUrl: "https://www.crisistextline.org",
  domesticViolence: "1-800-799-7233",
  suicide: "988",
  suicideUrl: "https://suicidepreventionlifeline.org/chat",
  trevorProject: "1-866-488-7386",
};

interface AdditionalHelpfulInfoProps {
  selectedUserId: string;
}

const AdditionalHelpfulInfo = ({
  selectedUserId,
}: AdditionalHelpfulInfoProps) => {
  const { externalId: appUserId } = useAppUserSelector();
  const { track } = useAnalytics();
  const trackLinkPressed = ({ field, linkType, text }: LinkPressProps) => {
    track(ProfileAnalyticsEvent.SafetyPlanLinkPressed, {
      [AnalyticsFieldName.AppUser]: appUserId,
      [AnalyticsFieldName.Component]: AdditionalHelpfulInfo.name,
      [AnalyticsFieldName.Field]: field,
      [AnalyticsFieldName.LinkType]: linkType,
      [AnalyticsFieldName.SelectedUser]: selectedUserId,
      [AnalyticsFieldName.Source]: ModalPath.SafetyPlanDetails,
      [AnalyticsFieldName.Text]: text,
    });
  };

  return (
    <VStack gap={24}>
      <Text testID={SafetyPlanTestID.AdditionalInfo} variant="h5">
        Additional helpful information
      </Text>
      <HotlinesSection
        crisisNumber={ContactInfo.suicide}
        domesticViolenceNumber={ContactInfo.domesticViolence}
        onLinkPress={trackLinkPressed}
        trevorProjectNumber={ContactInfo.trevorProject}
      />
      <ChatSuicideLineSection
        onLinkPress={trackLinkPressed}
        url={ContactInfo.suicideUrl}
      />
      <TextCrisisNumberSection
        onLinkPress={trackLinkPressed}
        phoneNumber={ContactInfo.crisis}
        url={ContactInfo.crisisUrl}
      />
      <WebsiteWithCrisisSkillsSection
        onLinkPress={trackLinkPressed}
        url={ContactInfo.crisisSkillsUrl}
      />
    </VStack>
  );
};

export type { AdditionalHelpfulInfoProps };
export default AdditionalHelpfulInfo;
